function show(){
    var show = document.getElementById('toggleMobileNav');
    show.classList.toggle('mobileNav');
}
let scrollpos = window.scrollY
const menu = document.querySelector('#collection_progress_overlay')
const trigger = document.querySelector('#initIgoNav')
const trigger_height = window.pageYOffset + trigger.getBoundingClientRect().bottom
const add_class_on_scroll = () => menu.classList.add("scrollable_top")
const remove_class_on_scroll = () => menu.classList.remove("scrollable_top")

  // window.addEventListener('scroll', function() { 
  //   scrollpos = window.scrollY;
  //   if (scrollpos > trigger_height) {
  //    remove_class_on_scroll(); 
  //   } else if (scrollpos <= trigger_height) {
  //     add_class_on_scroll();
  //   }
  // })
  
  window.onscroll = function(e) {
    // print "false" if direction is down and "true" if up
    if (document.getElementById("collection_progress_overlay")){
    if(this.oldScroll > this.scrollY){
      add_class_on_scroll()
    }else{
      remove_class_on_scroll()
    }
    this.oldScroll = this.scrollY;
  }
}
const openMenu = document.querySelector(".mobileIcon")
const initMenuList = document.querySelector(".mobileInit")
const mobileMenuList = document.querySelector("#desktopNavItems")
const mobileMenuList1 = document.querySelector("#initNavItems1")

openMenu.addEventListener('click', function() {
  mobileMenuList.classList.toggle("mobileHidden")
  window.scrollTo(0,0)
});

initMenuList.addEventListener('click', function() {
 mobileMenuList1.classList.toggle("mobileHidden") 
});

